import React from 'react'

export const ProjectCard = props => {
  return(
    <div className="col s12">
      <div className="card hoverable portfolio-card">
        <div className="card-image">
          <a href={props.url} target="_blank" rel="noopener noreferrer">
            <img className="portfolio-card-image" src={props.image} alt="project" style={{border: 'solid 1px black'}}/>
          </a>
        </div>
        <div className="card-content">
          <h4 className="card-title" style={{marginTop:0}}>{props.title}</h4>
          <p>{props.description}</p>
          <hr/>
          <p>Tech used: {props.tech.join(', ')}</p>
        </div>
        <div className="card-action">
          <a href={props.github} target="_blank" rel="noopener noreferrer">See the GitHub</a>
        </div>
      </div>
    </div>
  )
}